document.addEventListener('DOMContentLoaded', () => {
    const page = document.querySelector('.myaccount');
    if (!page) return;

    let input = null;

    // The hidden <input type="file"> lives inside the profile-details <form>
    // (with the API's expected name) so `new FormData(form)` picks it up at save time.
    function ensureInput() {
        if (input && input.isConnected) return input;

        const form = page.querySelector('[data-myaccount-form][data-tab-panel="profile-details"]');
        if (!form) return null;

        input = document.createElement('input');
        input.type   = 'file';
        input.name   = 'custom_id_attachment_url';
        input.accept = 'image/*,application/pdf';
        input.style.display = 'none';
        form.appendChild(input);

        input.addEventListener('change', () => {
            const file = input.files && input.files[0];
            if (!file) return;
            const fileName = page.querySelector('.myaccount__file-name');
            if (fileName) fileName.textContent = file.name;
        });
        return input;
    }

    page.addEventListener('click', (e) => {
        const btn = e.target.closest('.myaccount__file-replace');
        if (!btn || btn.disabled) return;
        const inp = ensureInput();
        if (inp) inp.click();
    });
});
